import {store} from "../redux/store";
import {getArticle} from "../action/getArticle";
import {setArticle} from "../redux/actions/setArticle";

export const articleLoader = async (args) => {
    store.dispatch(setArticle(await getArticle(args.params.slug)));
    return true;
}
